import Highcharts = require("highcharts");
import { LineSerie } from "./line.serie";
import { Component, OnInit, Inject } from "@angular/core";
import { DashboardDataService } from "../core/dashboarddataservice";
import HighchartsMore = require('highcharts/highcharts-more');
import SolidGauge = require("highcharts/modules/solid-gauge");

// Initialize Highcharts Solid Gauge
HighchartsMore(Highcharts);
SolidGauge(Highcharts);

@Component({
    selector: "crew-person-onboard-graph",
    template: require('./person-onboard-graph.component.html')
})
export class PersonsOnBoardGraphComponent implements OnInit {

    constructor(
        @Inject("$log") private $log: ng.ILogService,
        private dashboardDataService: DashboardDataService) {
    }

    ngOnInit() {

        this.dashboardDataService
            .searchDayOnBoard({ Day: null })
            .then(res => {
                var data: LineSerie[] = [];
                data.push({ name: '', y: res.CurrentlyOnBoard });
                this.refreshGraph(data, res.MaxOnBoard);
            })
            .catch(err => this.$log.error(err));
    }

    private refreshGraph(dataSource: LineSerie[], maxOnBoard: number) {
        var gaugeOptions = {

            chart: {
                type: 'solidgauge'
            },

            title: {
                text: 'Persons On-Board'
            },

            pane: {
                center: ['50%', '60%'],
                size: '100%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                }
            },

            tooltip: {
                enabled: false
            },

            // the value axis
            yAxis: {
                lineWidth: 0,
                minorTickInterval: null,
                tickAmount: 2,
                title: {
                    y: -70
                },
                labels: {
                    y: 16
                }
            },

            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: 5,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            }
        };

        Highcharts.chart('persons-onboard-graph', Highcharts.merge(gaugeOptions, {
            yAxis: {
                min: 0,
                max: maxOnBoard,
                title: {
                    text: null
                }
            },

            credits: {
                enabled: false
            },

            series: [{
                name: 'Persons On-Board',
                data: dataSource,
                dataLabels: {
                    format: '<div style="text-align:center"><span style="font-size:25px;color:' +
                    ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y}</span><br/>' +
                    '<span style="font-size:12px;color:silver">persons</span></div>'
                },
                tooltip: {
                    valueSuffix: ' persons'
                }
            }]
        }));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/person-onboard-graph.component.ts